import { useState } from "react";
import {
  IconShare3,
  IconCopy,
  IconCheck,
  IconBrandWhatsapp,
  IconBrandLinkedin,
  IconBrandX,
  IconBrandFacebook,
  IconMail,
} from "@tabler/icons-react";
import { shareNetworks, buildShareText } from "./data";
import styles from "./ShareModal.module.css";
import ModalShell from "../../../Support/ModalShell";

const NETWORK_ICONS = {
  whatsapp: IconBrandWhatsapp,
  linkedin: IconBrandLinkedin,
  x: IconBrandX,
  facebook: IconBrandFacebook,
  email: IconMail,
};

export default function ShareModal({ open, onClose, name, headline }) {
  const [copied, setCopied] = useState(false);

  const url =
    typeof window !== "undefined"
      ? window.location.origin + window.location.pathname
      : "";
  const text = buildShareText(name);

  function handleCopy() {
    function done() {
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done).catch(done);
    } else {
      done();
    }
  }

  return (
    <ModalShell
      open={open}
      onClose={onClose}
      icon={IconShare3}
      color="blue"
      title="Share this profile"
      subtitle={`${name} · ${headline}`}
    >
      <div className={styles.socialGrid}>
        {shareNetworks.map((n) => {
          const Icon = NETWORK_ICONS[n.id];
          return (
            <button
              key={n.id}
              type="button"
              className={styles.socialBtn}
              onClick={() =>
                window.open(n.build(url, text), "_blank", "noopener,noreferrer")
              }
            >
              <span
                className={styles.socialIcon}
                style={{ background: n.color }}
              >
                <Icon size={19} />
              </span>
              {n.label}
            </button>
          );
        })}
      </div>

      <span className={styles.copyLabel}>Or copy link</span>
      <div className={styles.copyRow}>
        <input type="text" value={url} readOnly />
        <button type="button" className={styles.copyBtn} onClick={handleCopy}>
          {copied ? <IconCheck size={15} /> : <IconCopy size={15} />}
          {copied ? "Copied!" : "Copy"}
        </button>
      </div>
    </ModalShell>
  );
}
